// extracted by mini-css-extract-plugin
export default {"wrapper":"ClockFace_wrapper__eD1Pn","text":"ClockFace_text__aoV50"};